/* AFRIKAANLOCKS — pilotage des carrousels (flèches + points).
   S'appuie sur le défilement natif : pas de dépendance, et si le JS
   ne se charge pas, le carrousel reste utilisable au doigt/trackpad. */
(function () {
  'use strict';

  function setup(root) {
    if (root.dataset.afkReady) return;
    root.dataset.afkReady = '1';

    var track = root.querySelector('.afk-carousel');
    if (!track) return;

    var prev = root.querySelector('[data-afk-prev]');
    var next = root.querySelector('[data-afk-next]');
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-afk-dot]'));

    function pageWidth() {
      var first = track.firstElementChild;
      if (!first) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap || '0') || 0;
      return first.getBoundingClientRect().width + gap;
    }

    function maxScroll() {
      return Math.max(0, track.scrollWidth - track.clientWidth);
    }

    function sync() {
      var x = track.scrollLeft;
      var max = maxScroll();
      if (prev) prev.disabled = x <= 1;
      if (next) next.disabled = x >= max - 1;

      if (dots.length) {
        // repartit la position de defilement sur le nombre de points
        var ratio = max > 0 ? x / max : 0;
        var active = Math.round(ratio * (dots.length - 1));
        dots.forEach(function (d, i) {
          d.setAttribute('aria-current', i === active ? 'true' : 'false');
        });
      }
    }

    if (prev) prev.addEventListener('click', function () { track.scrollLeft -= pageWidth(); });
    if (next) next.addEventListener('click', function () { track.scrollLeft += pageWidth(); });

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        var max = maxScroll();
        track.scrollLeft = dots.length > 1 ? (max * i) / (dots.length - 1) : 0;
      });
    });

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { sync(); ticking = false; });
    }, { passive: true });

    window.addEventListener('resize', sync);
    sync();
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-afk-carousel]').forEach(setup);
  }

  document.addEventListener('DOMContentLoaded', function () { init(); });
  init();

  // l'editeur de theme reconstruit les sections a la volee
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* Ajout au panier depuis une carte produit (accueil, collections) : on pousse
   l'article puis on ouvre le panier lateral, sans jamais quitter la page.

   Deux pieges corriges ici :
   - le selecteur ne couvrait que [data-afk-atc], donc les cartes des pages
     collection (form.afk-card__form) partaient en soumission classique et
     renvoyaient le client sur /cart ;
   - un seul .catch() couvrait a la fois le reseau, les refus de Shopify
     (rupture, quantite maximale) et l'ouverture du tiroir. Le moindre refus
     declenchait form.submit(), donc une redirection vers /cart. On distingue
     desormais les trois cas. */
(function () {
  'use strict';

  /* Ce fichier est appele par plusieurs sections ET par le layout : sans ce
     garde, l'ecouteur serait attache plusieurs fois et chaque clic ajouterait
     l'article autant de fois. */
  if (window.__afkAtcPret) return;
  window.__afkAtcPret = true;

  var SELECTEUR = 'form[data-afk-atc], form.afk-card__form';

  function openDrawer() {
    try {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      var trigger = document.querySelector('[data-drawer-options*="t4s-mini_cart"]');
      if (trigger) trigger.click();
    } catch (err) {
      /* le panier est a jour meme si le tiroir refuse de s'ouvrir : on ne
         redirige pas pour autant, ce serait pire que de ne rien faire */
    }
  }

  function message(form, texte) {
    if (!texte) return;
    var el = form.querySelector('.afk-atc-msg');
    if (!el) {
      el = document.createElement('p');
      el.className = 'afk-atc-msg';
      el.setAttribute('role', 'status');
      el.style.cssText = 'margin:6px 0 0;font-size:12px;line-height:1.35;color:#1B1913';
      form.appendChild(el);
    }
    el.textContent = texte;
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.remove(); }, 5000);
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest(SELECTEUR);
    if (!form) return;

    var id = form.querySelector('[name="id"]');
    if (!id || !window.fetch) return; // sans fetch, on laisse le navigateur faire

    e.preventDefault();
    var btn = form.querySelector('button[type="submit"]');
    if (btn) btn.disabled = true;

    var qte = form.querySelector('[name="quantity"]');
    var articles = [{ id: id.value, quantity: Number(qte && qte.value) || 1 }];

    /* Bloc « Complétez avec » : le bouton + doit aussi ajouter le produit de la
       page, sinon le client repart avec le seul produit complementaire. On ne
       l'ajoute que s'il manque au panier, pour ne pas le compter deux fois. */
    var principal = form.getAttribute('data-afk-main-id');
    if (principal) {
      // si le client a change de variante, c'est celle-ci qui fait foi
      var champ = document.querySelector('form[action*="/cart/add"]:not(.afk-card__form) [name="id"]');
      if (champ && champ.value) principal = champ.value;
    }

    var prepare = principal
      ? fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (panier) {
            var present = (panier.items || []).some(function (i) {
              return String(i.variant_id) === String(principal);
            });
            if (!present) articles.unshift({ id: principal, quantity: 1 });
          })
          .catch(function () { /* panier illisible : on ajoute au moins le complementaire */ })
      : Promise.resolve();

    prepare.then(function () {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: articles })
      });
    })
      .then(function (r) {
        return r.json().then(function (data) { return { ok: r.ok, data: data }; });
      })
      .then(function (res) {
        if (res.ok) { openDrawer(); return; }
        // refus de Shopify : rupture, quantite maximale... on informe sur place
        message(form, (res.data && (res.data.description || res.data.message)) || 'Ajout impossible.');
      })
      .catch(function () {
        message(form, 'Connexion interrompue. Reessayez dans un instant.');
      })
      .then(function () { if (btn) btn.disabled = false; });
  });
})();
